import { useContact } from '@revenuewell/front-end-bundle';
import {
  LocationSwitchEventData,
  SwitchLocationDialog
} from 'apps/wrapper/src/components/shared/dialog/switch-location-dialog/switch-location-dialog';
import { useEventBus } from 'apps/wrapper/src/hooks/use-event-bus';
import { useLocations } from 'apps/wrapper/src/hooks/use-locations';
import { useProductsByLocation } from 'apps/wrapper/src/hooks/use-products-by-location';
import { FC, useState } from 'react';
import { Phone1Loader } from './phone1-loader';
import { Phone2Loader } from './phone2-loader';

export const PhoneLoader: FC = () => {
  const { publish } = useEventBus();
  const { getContactsByPhoneNumber } = useContact();
  const { selectedLocation, locations, switchLocation } = useLocations();
  const { hasProduct, isLoading: isLoadingProducts } = useProductsByLocation(selectedLocation?.id);
  const [locationSwitchEvent, setLocationSwitchEvent] = useState<LocationSwitchEventData | null>(null);

  const handlePatientProfileClick = async (phoneNumber: string) => {
    if (!selectedLocation?.id) return;

    const contacts = await getContactsByPhoneNumber(phoneNumber);

    if (!contacts.length || !contacts[0].locationId) return;

    const contact = contacts[0];

    if (contact.locationId == selectedLocation?.id) {
      goToPatientProfile(phoneNumber, contact.locationId);
    } else {
      setLocationSwitchEvent({
        locationId: contacts[0].locationId,
        locationName: locations.find((l) => l.id == contact.locationId)?.name || '',
        patientPhone: phoneNumber,
        patientName: `${contact.firstName} ${contact.lastName}`
      });
    }
  };

  const handleLocationSwitch = async (data: LocationSwitchEventData) => {
    setLocationSwitchEvent(null);
    await switchLocation(data.locationId);
    goToPatientProfile(data.patientPhone, data.locationId);
  };

  const goToPatientProfile = (phoneNumber: string, locationId: number) => {
    publish({
      messageType: 'patientProfile',
      data: { phoneNumber, locationId }
    });
  };

  if (isLoadingProducts) return null;

  return (
    <>
      {(hasProduct('phone') || hasProduct('phone1')) && (
        <Phone1Loader onPatientProfileClick={handlePatientProfileClick} />
      )}
      {hasProduct('phone2') && <Phone2Loader onPatientProfileClick={handlePatientProfileClick} />}
      {locationSwitchEvent && (
        <SwitchLocationDialog
          eventData={locationSwitchEvent}
          message="This call is from a patient in another location. Would you like to switch locations and go to their profile?"
          onSwitchLocation={handleLocationSwitch}
          onClose={() => setLocationSwitchEvent(null)}
        />
      )}
    </>
  );
};
